class ComponentSearch extends HTMLElement {
  constructor() {
    super();
    this.searchField = this.querySelector('input[name="q"]');
    this.results = this.querySelector('.search-results');
    this.articles = this.querySelector('.search-results-articles')
    this.form = this.querySelector('form');
    this.searchDelay = 300;
    this.searchType = 'article,page';
    this.searchType2 = 'product'
    this.controller = null;
    this.requestTimeout = 0;

    if (this.dataset.autocomplete == "true") {
      this.documentClickHandler = this.documentClick.bind(this);
      this.searchField.addEventListener('input', this.doSearch.bind(this));
      // added to prevent redirect on enter press and go to first result
      this.searchField.addEventListener('keyup', (e) => {
        var keyCode = (e.keyCode || e.which || e.charCode || 0);
        e.target.value = e.target.value.replace(/[\W_]+/g," ");
        if (keyCode == 13) {
          e.preventDefault();
          if (this.results && this.results.children.length > 0) {
            if (document.querySelector('.tab-button.first').classList.contains('active')){
              location = this.form.action + '?' + searchParams.toString() + '#products';
            }else{
              location = this.form.action + '?' + searchParams.toString() + '#articles';
             }
          }          
          return false;
        }
      });
    }

    this.form.addEventListener('submit', (e)=>{
      e.preventDefault();
      const formData = new FormData(this.form);
      const searchParams = new URLSearchParams(formData);
      const query = searchParams.get('q');
      if(query && query!="") {
        searchParams.set('q', '*'+query+'*');
        if (document.querySelector('.tab-button.first').classList.contains('active')){
          location = this.form.action + '?' + searchParams.toString() + '#products';
        }else{
          location = this.form.action + '?' + searchParams.toString() + '#articles';
         }
      }
    });
  }

  //term param allows to trigger custom search from js code.
  doSearch(term) {
    term = typeof(term)=="string" ? term : '*'+this.searchField.value.replace(/[\W_]+/g," ").trim()+'*';
    if (this.controller) {
      this.controller.abort();
      this.controller = null;
    }
    clearTimeout(this.requestTimeout);
    if (term.length>=5) {
      this.showSearchingResults();
      this.requestTimeout = setTimeout(()=>{
        this.controller = $s.getJson({
          url: '/search?view=ajax_json&type='+ this.searchType +'&q='+ encodeURIComponent(term),
          success: (response)=>{
            this.clearResultsArticles(false);
            if (response.results_count > 0) {
              response.results.forEach((item)=>{
                this.articles.appendChild(this.buildItem(item));
              });
              if (response.results_count > response.results.length) {
                var linkUrl = '/search?type='+ this.searchType + ',' + this.searchType2 +'&q='+ encodeURIComponent(term) + "#articles";
                this.articles.appendChild(this.buildSeeAllLink(linkUrl, response.results_count));
              }
            } else {
              this.noResultsArticles();
            }
          }
        });
        this.controller = $s.getJson({
          url: '/search?view=ajax_json&type='+ this.searchType2 +'&q='+ encodeURIComponent(term),
          success: (response)=>{
            this.clearResults(false);
            if (response.results_count > 0) {
              response.results.forEach((item)=>{
                this.results.appendChild(this.buildItem(item));
              });
              if (response.results_count > response.results.length) {
                var linkUrl = '/search?type='+ this.searchType2 + ',' + this.searchType +'&q='+ encodeURIComponent(term) + "#products";
                this.results.appendChild(this.buildSeeAllLink(linkUrl, response.results_count));
              }
            } else {
              this.noResults();
            }
          }
        });
      }, this.searchDelay);
    } else {
      this.clearResults();
      this.clearResultsArticles();
    }
  }

  buildItem(itemJson) {
    //console.log(itemJson)
    var img = document.createElement('img');
    var title = document.createElement('div');
    var a = document.createElement('a');
    a.classList.add("item", "flex", "flex-1", "direction-row", "justify-content-start", "align-items-center");
    a.href = itemJson.url;
    if(itemJson.thumbnail.includes('no-image-50')){
      img.src = itemJson.blog;
    }else{
      img.src = itemJson.thumbnail;
    }
    title.innerHTML = itemJson.title;
    a.appendChild(img);
    a.appendChild(title);
    return a;
  }

  buildSeeAllLink(url, resultsQuantity) {
    var a = document.createElement('a');
    a.classList.add('see-all');
    a.href = url;
    a.innerHTML = 'See all ' + resultsQuantity + ' results';
    return a;
  }

  showSearchingResults() {
    if (!this.results.style.minHeight) {
      document.addEventListener('click', this.documentClickHandler);

      var height = this.results.offsetHeight;
      this.results.style.minHeight = Math.max(height, 80)  + 'px';
      this.results.innerHTML = '<div style="height: 100%;" class="loader-wrap flex justify-content-center align-items-center"><div class="loader" style="border-top-color: #ccc;"></div></div>';
    }
  }

  clearResults(removeEvents=true) {
    if(removeEvents) {
      document.removeEventListener('click', this.documentClickHandler);
    }
    this.results.innerHTML = '';
    this.results.style.minHeight = '';
  }

  clearResultsArticles(removeEvents=true) {
    if(removeEvents) {
      document.removeEventListener('click', this.documentClickHandler);
    }
    this.articles.innerHTML = '';
    this.articles.style.minHeight = '';
  }

  noResults() {
    this.results.innerHTML = '<div class="no-results">No results</div>';
  }

  noResultsArticles() {
    this.articles.innerHTML = '<div class="no-results">No results</div>';
  }


  documentClick(e) {
    if(!this.contains(e.target)) {
      this.clearResults();
    }
  }
}
if(!customElements.get("ComponentSearch")){
  customElements.define('search-form', ComponentSearch);
}
